module.exports = __webpack_public_path__ + "img/logo-sd.2cae2b38.png";